import React, {Component, Fragment} from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import styled from "styled-components"
import {connect} from "@irati/store"

import authentication from "@irati/auth"

import CreatePopup from "../Popup/CreatePoll"
import {INSPIRE} from "../Popup/CreatePoll/Popup"
import PollBase from "./OpenPoll/Poll"

import {
  CreateAPoll,
  HaveYourSay,
  SeeWhosVoting,
  GetInspired,
  EarnRewards
} from "./Empty/Cards"

const Poll = styled(PollBase)`
  margin: 10px 0;
`

class OpenPolls extends Component {
  state = {
    showCreate: false,
    showInspire: false
  }

  static propTypes = {
    polls: PropTypes.array.isRequired
  }

  handleCreate = () => this.setState({
    showCreate: true
  })

  handleGetInspired = () => this.setState({
    showCreate: true,
    showInspire: true
  })

  handleAfterExitCreateModal = () => this.setState({
    showCreate: false,
    showInspire: false
  })

  componentDidUpdate() {
    const {showCreate, showInspire} = this.state

    if (showCreate) {
      if (showInspire) {
        this.createPopup.show(INSPIRE)
      } else {
        this.createPopup.show()
      }
    }
  }

  createFirstEmptyPoll = () => {
    const canCreatePoll = authentication.apps("recognition.poll.create")
    return canCreatePoll
      ? <CreateAPoll onClick={this.handleCreate} />
      : <HaveYourSay />
  }

  createSecondEmptyPoll = () => {
    const canCreatePoll = authentication.apps("recognition.poll.create")
    return canCreatePoll
      ? <GetInspired onClick={this.handleGetInspired} />
      : <SeeWhosVoting />
  }

  createThirdEmptyPoll = () => {
    const canCreatePoll = authentication.apps("recognition.poll.create")
    const canReward = authentication.apps("recognition.rewards.create")

    if (canReward) {
      return <EarnRewards />
    }
    return canCreatePoll ? <SeeWhosVoting /> : null
  }

  render() {
    const {showCreate} = this.state
    const {polls} = this.props

    return (
      <Fragment>
        {polls.map((poll) => (
          <div key={poll.uuid}>
            <Poll poll={poll} />
          </div>
        ))}
        {polls.length <= 2 && this.createFirstEmptyPoll()}
        {polls.length <= 1 && this.createSecondEmptyPoll()}
        {polls.length === 0 && this.createThirdEmptyPoll()}
        {showCreate &&
          <CreatePopup
            ref={(c) => { this.createPopup = c }}
            onExited={this.handleAfterExitCreateModal} />
        }
      </Fragment>
    )
  }
}

const mapStateToProps = ({mq}) => ({
  isPhone: get(mq, "lessThan.medium", false),
  tabletBreakpoint: mq.breakpoints.small
})

export default connect(mapStateToProps)(OpenPolls)
